import React from "react";
import { withRouter } from "react-router-dom";
import ResourceDrawer from "../resourceDrawer";
import SideSection from "../small-components/SideSection";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Phase from "../small-components/Phase/Phase";
import MenuOpenIcon from "../../assets/images/menu-black.svg";
import menuopen_black from "../../assets/images/menu-open_black.svg";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import $ from "jquery";
import Sticky from "react-sticky-el";
import uuid from "react-uuid";
import fire from "../../config/firebase";
import { getCopyName } from "../../libs/getCopyName";
import { getOrderInt, orderItems, sortItems } from "../../libs/utils";
import NewDrawer from '../small-components/DuplicateTemplate/newDrawer'
import EditVendor from '../small-components/DuplicateTemplate/EditVendor';
const set = new Set();

class EstimateCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      qty: 0,
      countPhase: 0,
      expandSection: false,
      count: 0,
      newResourceName: "",
      newResourceType: "",
      newResourceData: {},
      drawerState: true,
      dialogOpen: false,
      ResourceDrawerOpen: false,
      EditVendorDrawer: false,
      resource: null,
      estimates: {},
      drawerOnSuccess: null,
      drawerOnCancel: null,
      timestamp: 0,
      updateResourceFn: () => { }
    };
    this.refreshData = this.refreshData.bind(this);
    this.createDuplicatePhase = this.createDuplicatePhase.bind(this);
    this.createPhase = this.createPhase.bind(this);
    this.reorderPhases = this.reorderPhases.bind(this);
    this.handleCtrlZ = this.handleCtrlZ.bind(this);

    this.addPhase = this.addPhase.bind(this);
    this.updateEstimateTable = this.updateEstimateTable.bind(this);
    this.range = this.range.bind(this);

    this.updateResourceHours = this.updateResourceHours.bind(this);
    this.updateResourceName = this.updateResourceName.bind(this);

    this.deleteHandler = this.deleteHandler.bind(this);

    this.closeHandler = this.closeHandler.bind(this);
    this.sectionExpand = this.sectionExpand.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.drawerInfoUpdate = this.drawerInfoUpdate.bind(this);

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.deletePhase = this.deletePhase.bind(this);
    this.toggleEditDrawer = this.toggleEditDrawer.bind(this);
  }

  handleCtrlZ(event) {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    if (["INPUT", "TEXTAREA"].indexOf(event.target.tagName) > -1) {
      return;
    }
    const { ctrlKey, keyCode, metaKey } = event;
    if ((!!ctrlKey || !!metaKey) && keyCode === 90) {
      const undoData = JSON.parse(localStorage.getItem("undoData"));
      let spliceData = "";
      let phases = [];
      if (undoData.length > 0 && undoData[0]["action"] === "addPhase") {
        let flag = 0;
        if (this.state.estimates) {
          if (flag === 0) {
            flag = 1;
            phases = this.state.estimates["phases"];
            phases.splice(phases.length - 1, 1);
          }
        }
        if (undoData.length > 1) {
          spliceData = undoData.splice(0, 1);
        } else {
          spliceData = [];
        }
        let listRef = fire.database().ref("estimates/" + key);
        if (dataType === "templates") {
          listRef = fire.database().ref("templates/" + key);
        }

        listRef.update({
          phases: phases,
        });
        localStorage.setItem("undoData", JSON.stringify(spliceData));
      }
    }
  }
  refreshData(timestamp = new Date().getTime()) {
    this.props.update();

    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const estimateRef = fire.database().ref(`${dataType}/${key}`);
    estimateRef.once("value").then(
      (snapshot) => {
        const estimates = snapshot.val() || {};
        estimateRef.off("value");
        if (set.has(timestamp)) {
          return;
        }
        set.add(timestamp);
        if (estimates && estimates.phases) {
          estimates.phases.forEach((phase) => {
            if (!phase.tasks) {
              phase.tasks = [];
            }
          });
          this.setState({
            estimates,
            timestamp,
          });
        } else {
          const generatedPhaseId = uuid();
          const phase = {
            phaseId: generatedPhaseId,
            phaseName: "",
            phaseOrder: 1,
            tasks: [],
          };
          if (estimates && !estimates.phases) {
            estimates.phases = [phase];
          }
          this.setState(
            {
              estimates,
            },
            () => this.updateEstimateTable({ phases: estimates.phases }, false)
          );
        }
      },
      (error) => {
        console.log("Error: " + error.code);
      }
    );
  }
  componentWillReceiveProps(newProps) {
    if (newProps.updateCnt !== this.props.updateCnt) {
      this.refreshData();
    }
  }
  componentDidMount() {
    const refCompany = fire.database().ref("company");
    refCompany.once("value").then((snapshot) => {
      if (snapshot.exists()) {
        const company = snapshot.val();
        refCompany.off("value");
        const calculations = (company.arrayItem || []).map(
          (autocalculation) => {
            autocalculation.figure = parseInt(autocalculation.figure);
            return autocalculation;
          }
        );

        this.setState({
          calculations,
          company,
        });
      }
    });
    document.addEventListener("keydown", this.handleCtrlZ);

    $(document).on("input change", ".phase-name input", function () {
      const value = $(this).val();
      const index = $(this).parents(".phase-parent").index();
      $(
        "#scope .small-col .inner-content:eq(" + index + ") .phase-text span"
      ).text(value);
    });
    $(document).on("input change", ".taskName input", function () {
      const value = $(this).val();
      const index = $(this).parents(".task-count").index();
      const parentIndex = $(this).parents(".phase-parent").index();
      if (
        index >=
        $("#scope .small-col .inner-content:eq(" + parentIndex + ") li").length
      ) {
        $("#scope .small-col .inner-content:eq(" + parentIndex + ") ul").append(
          "<li><span>" + value + "</span></li>"
        );
      } else {
        $(
          "#scope .small-col .inner-content:eq(" +
          parentIndex +
          ") li:eq(" +
          index +
          ") span"
        ).text(value);
      }
    });

    $(document).on(
      "click",
      ".summary-details .small-col .phase-text > span",
      function () {
        const text = $(this).parents(".inner-content").index();
        $(".phase-parent").each(function () {
          const valu = $(this).index();
          if (text === valu) {
            $("html, body").animate(
              {
                scrollTop: $(this).offset().top - 90,
              },
              500
            );
          }
        });
      }
    );
    $(document).on(
      "click",
      ".summary-details .small-col .phase-text > span",
      function () {
        const text = $(this).parents(".inner-content").index();
        $(".phase-parent").each(function () {
          const valu = $(this).index();
          if (text === valu) {
            $("html, body").animate(
              {
                scrollTop: $(this).offset().top - 90,
              },
              500
            );
          }
        });
      }
    );
    $(document).on(
      "click",
      ".summary-details .small-col .inner-content ul li",
      function () {
        const index = $(this).parents(".inner-content").index();
        const index1 = $(this).index();
        $(".phase-parent:eq(" + index + ") .task-count").each(function () {
          const valu = $(this).index();
          if (index1 === valu) {
            $("html, body").animate(
              {
                scrollTop: $(this).offset().top - 90,
              },
              500
            );
          }
        });
      }
    );
    $(document).on(
      "click",
      ".summary-details .small-col .inner-title .logo-wrap",
      function () {
        if ($(this).parents(".scope-tab").hasClass("hide-content")) {
          $(this).parents(".scope-tab").removeClass("hide-content");
          $(this)
            .parents(".scope-tab")
            .find(" .small-col .inner-title .text-outer")
            .fadeIn(1000);
          $(this)
            .parents(".scope-tab")
            .find(" .small-col .outer-content ")
            .fadeIn(1000);
        } else {
          $(this).parents(".scope-tab").addClass("hide-content");
          $(this)
            .parents(".scope-tab")
            .find(" .small-col .inner-title  .text-outer")
            .fadeOut(50);
          $(this)
            .parents(".scope-tab")
            .find(" .small-col .outer-content ")
            .fadeOut(50);
        }
      }
    );
    $(document).on("click", ".summary-details .tabs-wrap li", function () {
      $(".estimated-list .scope-tab .small-grid div").removeAttr("style");
    });

    this.refreshData();

    // To add animation on adding new phase div

    $(document).on('click', '.summary-details .scope-tab .plus-row button', function () {
      const phase_len = $('.summary-details .phase-parent').length - 1;
      $('.phase-parent').removeClass('new-item');
      const take_len = $('.phase-parent:eq(' + phase_len + ')');
      take_len.addClass('new-item');
      const phase_length = $('.summary-details .phase-parent').length - 1;
      const take_length = $('.phase-parent:eq(' + phase_length + ')');
      setTimeout(function () {
        $('.phase-parent').removeClass('new-item');
      }, 500)
    })
    if ($('section.estimated-list').length > 0) {
      $('html').addClass('edit_estimates');
    }
    // --- end --
  }
  addPhase() {
    let undoData = JSON.parse(localStorage.getItem("undoData"));
    if (!undoData) {
      undoData = [];
    }
    undoData.unshift({
      state: "phasesAsComponents",
      action: "addPhase",
    });
    localStorage.setItem("undoData", JSON.stringify(undoData));
    const generatedPhaseId = uuid();
    const num = this.state.estimates.phases.length + 1;
    const phase = {
      phaseId: generatedPhaseId,
      phaseOrder: num,
      phaseName: "",
      tasks: [],
    };
    const { phases = [] } = this.state.estimates;
    phases.push(phase);
    this.updateEstimateTable({ phases });
  }
  updateEstimateTable(updateData, refreshData = true) {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const estimateRef = fire.database().ref(`${dataType}/${key}`);

    const estimateData = this.state.estimates;
    let type = "",
      filterType = "";
    if (estimateData.typeOf === "TIME BASED ESTIMATE") {
      type = "TIME BASED ESTIMATE";
      filterType = "time-based";
    } else {
      type = "TASK BASED ESTIMATE";
      filterType = "task-based";
    }

    estimateData.type = type;
    estimateData.filterType = filterType;
    const newEstimateData = Object.assign({}, estimateData, updateData);

    estimateRef.update(newEstimateData);
    if (refreshData) {
      this.refreshData();
    }
  }
  range(min, max) {
    if (min < max) {
      return [...Array(max - min + 1).keys()].map((i) => i + min);
    } else {
      return [...Array(min - max + 1).keys()].map((i) => i + max);
    }
  }
  reorderPhases(data) {
    if (
      !data ||
      !data.source ||
      !data.destination ||
      data.destination.phaseId === data.source.phaseId
    ) {
      return;
    }
    const { phases } = this.state.estimates;
    const { source, destination } = data;
    const phasesOrdered = orderItems({
      list: phases,
      field: "phaseOrder",
      source,
      destination,
      nameField: "phaseName",
    });

    this.updateEstimateTable({ phases: phasesOrdered });
  }

  updateResourceHours(phaseId, taskId, resourceId, additionalHours) {
    const phases = [...this.state.estimates.phases];
    //find the correct phase by matching the phase id
    const phaseIndex = phases.findIndex((phase) => phase.phaseId === phaseId);
    //reach to the tasks array then find the correct task by matching the task id
    const taskIndex = phases[phaseIndex].tasks.findIndex(
      (task) => task.taskId === taskId
    );
    const resource = phases[phaseIndex].tasks[taskIndex].resources;
    const resourceIndex = 0;
    if (resource !== undefined) {
      resource.findIndex((resource) => resource.resourceId === resourceId);
    }
    // resource.findIndex(resource => resource.resourceId === resourceId)
    //in the task add the resource to the resources array
    if (resourceIndex > 0) {
      phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].hours =
        additionalHours;
    }

    this.updateEstimateTable({ phases });
  }
  updateResourceName(
    phaseId,
    taskId,
    resourceId,
    resourceName,
    cost,
    amount,
    qty
  ) {
    // console.log('update Resource')
    // console.log(resourceName, cost, amount)
    const phases = [...this.state.estimates.phases];
    //find the correct phase by matching the phase id
    const phaseIndex = phases.findIndex((phase) => phase.phaseId === phaseId);
    //reach to the tasks array then find the correct task by matching the task id
    const taskIndex = phases[phaseIndex].tasks.findIndex(
      (task) => task.taskId === taskId
    );
    const resourceIndex = phases[phaseIndex].tasks[
      taskIndex
    ].resources.findIndex((resource) => resource.resourceId === resourceId);
    //in the task add the resource to the resources array
    phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].title =
      resourceName;
    phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].resourceName =
      resourceName;
    phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].cost =
      parseFloat(cost || 0);
    phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].amount =
      parseFloat(amount || 0);
    phases[phaseIndex].tasks[taskIndex].resources[resourceIndex].qty = qty;

    this.updateEstimateTable({ phases }, true);
  }
  createDuplicatePhase(sourcePhase) {
    const copy = { ...sourcePhase };
    copy.phaseName = getCopyName(copy.phaseName || 'Phase Name', this.state.estimates.phases, 'phaseName');
    copy.phaseId = uuid();
    this.createPhase(copy);
  }
  createPhase(copy) {
    const phaseState = Array.from(this.state.estimates.phases);
    let order = 0;
    phaseState.forEach((phase) => {
      order = Math.max(getOrderInt(phase.phaseOrder) + 1, order);
    });
    copy.phaseId = uuid();
    copy.phaseOrder = order;
    phaseState.push(copy);
    this.updateEstimateTable({ phases: phaseState });
  }
  deletePhase(phase) {
    const phases = this.state.estimates.phases.filter(
      (d) => d.phaseId !== phase.phaseId
    );
    this.updateEstimateTable({ phases });
  }

  deleteHandler(key) {
    const phases = [...this.state.estimates.phases];
    const phaseIndex = phases.findIndex((d) => d.phaseId === key);
    const phase = phases[phaseIndex];
    const order = getOrderInt(phase.phaseOrder);
    const newPhases = phases.filter((d) => d.phaseId !== key);
    newPhases.forEach((phase) => {
      const position = getOrderInt(phase.phaseOrder);
      if (order < position) {
        phase.phaseOrder = position - 1;
      }
    });
    this.updateEstimateTable({ phases: newPhases });
  }
  closeHandler() {
    this.setState({ dialogOpen: false });
  }
  sectionExpand(e) {
    e.currentTarget.closest(".inner-content").classList.toggle("active");
  }
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    const data = {
      source: this.state.estimates.phases[result.source.index],
      destination: this.state.estimates.phases[result.destination.index],
    };
    this.reorderPhases(data);
  }
  drawerInfoUpdate(data, drawerOnSuccess, drawerOnCancel) {
    this.setState({
      newResourceName: data.resourceName,
      newResourceType: data.type,
      newResourceData: data,
      drawerOnSuccess,
      drawerOnCancel,
    });
  }
  toggleDrawer() {
    this.setState({
      ResourceDrawerOpen: !this.state.ResourceDrawerOpen,
    });
  }
  toggleEditDrawer(resource, updateResourceFn = () => { }) {
    this.setState({
      EditVendorDrawer: !this.state.EditVendorDrawer,
      resource: !this.state.EditVendorDrawer ? resource : null,
      updateResourceFn: updateResourceFn
    });
  }
  render() {
    const { updateCnt } = this.props;
    const { calculations = [] } = this.state;
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const { estimates = {} } = this.state;
    const { phases = [] } = estimates;
    sortItems({ list: phases, field: "phaseOrder", nameField: "phaseName" });
    return (
      <div id="scope" className="col s12 l12 scope-tab table">
        <div className="row">
          <div className="col s10 large-grid" style={{ position: "relative" }}>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul {...provided.droppableProps} ref={provided.innerRef}>
                    {phases?.map((phase, index) => (
                      <Draggable
                        key={"dragkey-" + phase.phaseId}
                        draggableId={`drag-${phase.phaseId}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            className="phase-parent"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Phase
                              key={phase.phaseId}
                              updateCnt={updateCnt}
                              deletePhase={this.deletePhase}
                              refreshData={this.refreshData}
                              estimateKey={key}
                              classes={this.props.classes}
                              createDuplicate={this.createDuplicatePhase}
                              toggleDrawer={this.toggleDrawer}
                              drawerInfoUpdate={this.drawerInfoUpdate}
                              phase={phase}
                              estimates={estimates}
                              calculations={calculations}
                              update={this.props.update}
                              toggleEditDrawer={this.toggleEditDrawer}
                              editVendorValue={this.state.editVendorValue}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>

            <Tooltip title="Add a Phase" interactive placement="top">
              <div className="plus-row">
                <IconButton
                  aria-label="add"
                  className={this.props.classes.plusIcon}
                  onClick={this.addPhase}
                >
                  <AddCircleIcon style={{ fontSize: 44, color: "#e70a89" }} />
                </IconButton>
              </div>
            </Tooltip>
          </div>
          <div className="col s2 small-grid">
            <Sticky
              topOffset={-237}
              stickyClassName={"sidenavsSticky"}
              boundaryElement="header"
              relative="true"
            >
              <div className="small-col">
                <div className="inner-title">
                  <span className={"logo-wrap"}>
                    <img src={MenuOpenIcon} alt="menu" className="close-icon" />
                    <img
                      className="open-icon"
                      src={menuopen_black}
                      alt="open"
                    />
                  </span>
                  <span className={"text-outer"}> Sections</span>
                </div>
                <div className="outer-content">
                  {this.state.estimates?.phases?.map((phase) => (
                    <SideSection
                      classes={this.props.classes}
                      key={
                        phase.phaseId + phase?.tasks?.join((d) => d.taskName)
                      }
                      keyite={
                        phase.phaseId + phase?.tasks?.join((d) => d.taskName)
                      }
                      name={phase.phaseName}
                      tasks={phase.tasks}
                    />
                  ))}
                </div>
              </div>
            </Sticky>
          </div>
        </div>
        {this.state.ResourceDrawerOpen ? (
          <ResourceDrawer
            key={this.state.newResourceData.newResourceName}
            id={this.props.match.params}
            dataType={this.props.match.path.includes("estimates")
              ? "estimates"
              : "templates"}
            open={this.state.ResourceDrawerOpen}
            toggle={this.toggleDrawer}
            newResourceData={this.state.newResourceData}
            onSuccess={this.state.drawerOnSuccess}
            onCancel={() => {
              this.refreshData();
              if (this.state.drawerOnCancel) {
                this.state.drawerOnCancel();
              }
            }}
          />
        ) : null}

        {this.state.updateResourceFn && this.state.EditVendorDrawer && this.state.resource ?
          <div className='MuiPaper-root MuiDrawer-paper MuiDrawer-paperAnchorRight MuiPaper-elevation16' style={{ zIndex: '1500 !important' }}>
            <div id='duplicate' className='side-item'>
              {/* <EditVendor
            key={this.state.resource.resourceId}
            resource={this.state.resource}
            refreshData={this.refreshData}
            toggleEditDrawer={this.toggleEditDrawer}
            estimate={estimates}
            updateResourceFn={this.state.updateResourceFn}
            onClose={() => {
              this.setState({
                EditVendorDrawer: false,
                resource: null,
                updateResourceFn: null
              });
            }}
          /> */}

              <NewDrawer
                key={this.state.resource.resourceId}
                resource={this.state.resource}
                refreshData={this.refreshData}
                toggleEditDrawer={this.toggleEditDrawer}
                estimate={estimates}
                updateResourceFn={this.state.updateResourceFn}
                open={true}
                toggle={true}
                onClose={() => {
                  this.setState({
                    EditVendorDrawer: false,
                    resource: null,
                    updateResourceFn: null
                  });
                }}
              />

              {/* {this.state.EditVendorDrawer ?
          <NewDrawer open={true} toggle={true}/> : null} */}

            </div>
          </div> : null}

      </div>
    );
  }
}
export default withRouter(EstimateCalculator);
